import { MouseEventHandler, ReactNode } from 'react';
import SharedButton from '../buttons/shared-button';

export interface LandingAction {
  label: string;
  icon: ReactNode;
  variant: 'outlined' | 'contained';
  mediaLink: string;
}

export function LandingActionButton({
  action,
  onClick,
}: {
  action: LandingAction;
  onClick?: MouseEventHandler<HTMLButtonElement>;
}) {
  const customButtonStyles = {
    px: 3,
    py: 1,
  };

  if (action.variant === 'contained') {
    return (
      <SharedButton
        size="medium"
        variant="primary"
        startIcon={action.icon}
        sx={{
          ...customButtonStyles,
        }}
        onClick={onClick}
      >
        {action.label}
      </SharedButton>
    );
  }

  return (
    <SharedButton
      size="medium"
      variant="secondary"
      startIcon={action.icon}
      sx={{
        ...customButtonStyles,
      }}
      onClick={onClick}
    >
      {action.label}
    </SharedButton>
  );
}
